import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm, ValidationError } from '@formspree/react';

interface ContactFormProps {
  formId: string;
}

const ContactForm: React.FC<ContactFormProps> = ({ formId }) => {
  const [formState, handleSubmit] = useForm(formId);

  return (
    <div className="bg-dark p-4 rounded shadow-sm">
      <h4 className="mb-4">Send Me a Message</h4>
      {formState.succeeded ? (
        <div className="mt-3 text-success">
          Thank you for your message! I'll get back to you soon.
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control 
                  type="text" 
                  name="name" 
                  placeholder="Your name"
                  required 
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control 
                  type="email" 
                  name="email" 
                  placeholder="your.email@example.com"
                  required 
                  className="bg-dark text-light border-secondary"
                />
                <ValidationError 
                  prefix="Email" 
                  field="email"
                  errors={formState.errors}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="message">
            <Form.Label>Message</Form.Label>
            <Form.Control 
              as="textarea" 
              name="message" 
              rows={4} 
              placeholder="Your message"
              required
              className="bg-dark text-light border-secondary"
            />
            <ValidationError 
              prefix="Message" 
              field="message"
              errors={formState.errors}
            />
          </Form.Group>
          <Button 
            variant="primary" 
            type="submit" 
            disabled={formState.submitting}
            className="mt-2"
          >
            {formState.submitting ? 'Sending...' : 'Send Message'}
          </Button>
        </Form>
      )}
    </div>
  );
};

export default ContactForm;
